module.exports = __webpack_public_path__ + "img/1.9fa044f8.png";